<template>
  <div>
    <b-modal id="modalRemoverUsuario" ref="modalRemoverUsuario" title="Select users to remove">
      <ListaParticipantesRemoverUsuarios />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListaParticipantesRemoverUsuarios from './ListaParticipantesRemoverUsuarios.vue';

export default {
  components: {
    ListaParticipantesRemoverUsuarios,
  },
  methods: {
    toogleModal() {
      this.$refs.modalRemoverUsuario.toggle();
    },
  },
};
</script>

<style>
</style>
